import _ from 'lodash';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import PageContainer from './PageContainer';
import Header from './Header';
import Footer from './Footer';
import AuthService from '../services/AuthService';
import { getPageType } from '../util/page';

const AdditionalMenu = ({ match }) => {
  const dispatch = useDispatch();
  const openKeys = useSelector(state => state.menu.openKeys);
  const menuTree = useSelector(state => state.app.menuTree);

  const onOpenChange = payload => {
    dispatch({ type: 'menu/setOpenKeys', payload });
  };

  const getCrumbs = () => {
    return [
      { name: 'Home', url: '/home' },
      { name: _.upperFirst(match.params.pageName), active: true },
    ];
  };

  const renderMenu = navPageType => {
    navPageType = _.upperFirst(navPageType);

    const hasPages = (menu = [], hasLeaf = {}) => {
      menu.forEach((obj = {}) => {
        if (hasLeaf.yes) {
          return;
        }
        if (obj.menu) {
          hasPages(obj.menu, hasLeaf);
        } else {
          if (AuthService.hasPermission(obj.name)) {
            hasLeaf.yes = true;
          }
        }
      });
    };

    const subMenuTree = _.find(menuTree, { name: navPageType });

    // In case subMenuTree isn't found, fallback to empty array
    const menuItems = _.get(subMenuTree, 'menu', []);

    const createMenu = (branch = []) => {
      const subMenu = [];
      branch.forEach((obj = {}) => {
        if (obj.menu) {
          const icon = _.indexOf(openKeys, obj.name) !== -1 ? 'folder-outline' : 'folder';
          const label = obj.title ? `${obj.name} - ${obj.title}` : obj.name;
          const hasLeaf = { yes: false };

          hasPages(obj.menu, hasLeaf);
          if (hasLeaf.yes) {
            const title = (
              <span>
                <i className={`zmdi zmdi-${icon} zmdi-hc-fw zmdi-hc-lg`} style={{ paddingRight: '10px' }} />
                {label}
              </span>
            );
            subMenu.push(
              <SubMenu key={obj.name} id={obj.name} title={title}>
                {createMenu(obj.menu)}
              </SubMenu>
            );
          }
        } else {
          if (!obj.hidden && AuthService.hasPermission(obj.name)) {
            const linkType = getPageType(obj.routeType);
            const iconTag = <i className={`zmdi zmdi-${linkType.icon} zmdi-hc-fw zmdi-hc-lg`} />;
            const to = `/${obj.name}`;

            subMenu.push(
              <MenuItem key={obj.name} id={obj.name}>
                <Link className="menu-item" to={to}>
                  {iconTag} {obj.name} - {obj.title}
                  <span className="menu-description"> - {obj.description}</span>
                </Link>
              </MenuItem>
            );
          }
        }
      });
      return subMenu;
    };

    return (
      <Menu mode="inline" onOpenChange={onOpenChange} openKeys={openKeys}>
        {createMenu(menuItems).map(c => c)}
      </Menu>
    );
  };

  const pageName = _.upperFirst(match.params.pageName);

  return (
    <PageContainer>
      <Header
        hasDocs={false}
        pageName={pageName}
        showFavorite={false}
        showInfo={false}
        title={pageName}
      />
      <div id="menu-container" style={{ flexGrow: 1 }}>
        {renderMenu(pageName)}
      </div>
      <Footer />
    </PageContainer>
  );
};

AdditionalMenu.propTypes = {
  match: PropTypes.object,
};

export default AdditionalMenu;
